import { SickDay } from "../models/SickDay";
import { FormGetResponse } from "../models/Form";
import { FieldAlias, FieldGroupId } from "../lib/enums";
import { CareDay } from "../models/CareDay";
import { Immunoglobulin } from "../models/Immunoglobulin";
import { EQ5D5L } from "../models/EQ5D5L";
import { sortByDateFunction } from "./dateHelpers";
import { Vaccination } from "../models/Vaccination";
import { Antibiotic } from "../models/Antibiotic";

export const convertFormsToSickDays = (forms: FormGetResponse[]) => {
  const sickdays = [] as SickDay[];
  forms.forEach((form) => {
    const values = form.values;
    if (values.length === 0) {
      return;
    }
    const startDatum = values.find(
      (v) => v.fieldAlias === FieldAlias.D_SJUKSKRIVNING_1_START_DATUM
    )?.value;
    const endDatum = values.find(
      (v) => v.fieldAlias === FieldAlias.D_SJUKSKRIVNING_2_SLUT_DATUM
    )?.value;
    const infectionRelated = values.find(
      (v) => v.fieldAlias === FieldAlias.D_SJUKSKRIVNING_3_INFECTIONRELATED
    )?.value;
    const working = values.find(
      (v) => v.fieldAlias === FieldAlias.D_SJUKSKRIVNING_4_WORKING
    )?.value;
    const workingPercent = values.find(
      (v) => v.fieldAlias === FieldAlias.D_SJUKSKRIVNING_5_WORKINGPERCENT
    )?.value;
    const numberOfDays = values.find(
      (v) => v.fieldAlias === FieldAlias.D_SJUKSKRIVNING_NUMBEROFDAYS
    )?.value;
    const sickday = {
      startDatum: startDatum,
      endDatum: endDatum,
      infectionRelated: infectionRelated,
      working: working,
      workingPercent: workingPercent,
      numberOfDays: numberOfDays,
    } as SickDay;
    sickdays.push(sickday);
  });
  return sickdays.sort(sortByDateFunction((s: SickDay) => s.startDatum));
};

export const convertFormsToCareDays = (forms: FormGetResponse[]) => {
  const careDays = [] as CareDay[];
  forms.forEach((form) => {
    const values = form.values;
    if (values.length === 0) {
      return;
    }
    const startDatum = values.find(
      (v) => v.fieldAlias === FieldAlias.D_CAREDAYS_1_DATESTART
    )?.value;
    const endDatum = values.find(
      (v) => v.fieldAlias === FieldAlias.D_CAREDAYS_2_DATEEND
    )?.value;
    const infectionRelated = values.find(
      (v) => v.fieldAlias === FieldAlias.D_CAREDAYS_3_INFECTION
    )?.value;
    const numberOfDays = values.find(
      (v) => v.fieldAlias === FieldAlias.C_D_CAREDAYS_NUMBER_OF_DAYS
    )?.value;
    const careDay = {
      startDatum: startDatum,
      endDatum: endDatum,
      infectionRelated: infectionRelated,
      numberOfDays: numberOfDays,
    } as CareDay;
    careDays.push(careDay);
  });
  return careDays.sort(sortByDateFunction((c: CareDay) => c.startDatum));
};

export const convertFormsToImmunoglobulins = (forms: FormGetResponse[]) => {
  const immunoglobulins = [] as Immunoglobulin[];
  forms.forEach((form) => {
    const values = form.values;
    if (values.length === 0) {
      return;
    }
    const date = values.find(
      (v) => v.fieldAlias === FieldAlias.D_PERGAMMA_1_DATE
    )?.value;
    const drug = values.find(
      (v) => v.fieldAlias === FieldAlias.D_PERGAMMA_2_DRUG
    )?.value;
    const dosage = values.find(
      (v) => v.fieldAlias === FieldAlias.D_PERGAMMA_3_DOSAGE
    )?.value;
    const batch = values.find(
      (v) => v.fieldAlias === FieldAlias.D_PERGAMMA_4_BATCH
    )?.value;
    const adverseEvent = values.find(
      (v) => v.fieldAlias === FieldAlias.D_PERGAMMA_5_ADVERSE_EVENT
    )?.value;
    const immunoglobulin = {
      date: date,
      drug: drug,
      dosage: dosage,
      batch: batch,
      adverseEvent: adverseEvent,
    } as Immunoglobulin;
    immunoglobulins.push(immunoglobulin);
  });
  return immunoglobulins.sort(
    sortByDateFunction((i: Immunoglobulin) => i.date)
  );
};

export const convertFormsToVaccinations = (forms: FormGetResponse[]) => {
  const vaccinations = [] as Vaccination[];
  forms.forEach((form) => {
    const values = form.values;
    if (values.length === 0) {
      return;
    }
    /*
    const date = values.find(v => v.fieldAlias === FieldAlias...)?.value;
    const vaccination = values.find(v => v.fieldAlias === FieldAlias...)?.value;

    const vac = {
      date: date,
      vaccination: vaccination
    } as Vaccination;
    vaccinations.push(immunoglobulin);
    */
  });
  return vaccinations.sort(sortByDateFunction((v: Vaccination) => v.date));
};

export const convertFormsToAntibiotics = (forms: FormGetResponse[]) => {
  const antibiotics = [] as Antibiotic[];
  forms.forEach((form) => {
    const values = form.values;
    if (values.length === 0) {
      return;
    }
    /*
    const startDatum = values.find(v => v.fieldAlias === FieldAlias...)?.value;
    const endDatum = values.find(v => v.fieldAlias === FieldAlias...)?.value;
    const substansnamn = values.find(v => v.fieldAlias === FieldAlias...)?.value;
    const indikation = values.find(v => v.fieldAlias === FieldAlias...)?.value;

    const antibiotic = {
      startDatum: startDatum,
      endDatum: endDatum,
      substansnamn: substansnamn,
      indikation: indikation
    } as Antibiotic;
    antibiotics.push(antibiotic);
    */
  });
  return antibiotics.sort(sortByDateFunction((v: Antibiotic) => v.startDatum));
};

export const convertFormsToEQ5D5Ls = (forms: FormGetResponse[]) => {
  const eQ5D5Ls = [] as EQ5D5L[];
  forms.forEach((form) => {
    const values = form.values;
    if (values.length === 0) {
      return;
    }
    const vas = values.find(
      (v) => v.fieldAlias === FieldAlias.D_EQ5D_6_VAS
    )?.value;
    const rorlighet = values.find(
      (v) => v.fieldAlias === FieldAlias.D_EQ5D_1_RORLIGHET
    )?.value;
    const hygien = values.find(
      (v) => v.fieldAlias === FieldAlias.D_EQ5D_2_HYGIEN
    )?.value;
    const huvudsakligaAktiviteter = values.find(
      (v) => v.fieldAlias === FieldAlias.D_EQ5D_3_HUVUDSAKLIGAAKTRIVITETER
    )?.value;
    const smartor = values.find(
      (v) => v.fieldAlias === FieldAlias.D_EQ5D_4_SMARTOR
    )?.value;
    const oro = values.find(
      (v) => v.fieldAlias === FieldAlias.D_EQ5D_5_ORO
    )?.value;
    const datum = values.find(
      (v) => v.fieldAlias === FieldAlias.D_EQ5D_DATUM
    )?.value;
    const eq5 = {
      vas: vas,
      rorlighet: rorlighet,
      hygien: hygien,
      huvudsakligaAktiviteter: huvudsakligaAktiviteter,
      smartor: smartor,
      oro: oro,
      datum: datum,
    } as EQ5D5L;
    eQ5D5Ls.push(eq5);
  });
  return eQ5D5Ls;
};

export const getPrefilledFormValues = (
  fieldGroupId: number,
  formValues: any
) => {
  switch (fieldGroupId) {
    case FieldGroupId.IMMUNOGLOBULIN_FIELD_GROUP_ID:
      return {
        formId: FieldGroupId.IMMUNOGLOBULIN_FIELD_GROUP_ID,
        values: [
          {
            fieldAlias: FieldAlias.D_PERGAMMA_2_DRUG,
            value: formValues?.drug || -1,
          },
          {
            fieldAlias: FieldAlias.D_PERGAMMA_3_DOSAGE,
            value: formValues?.dosage || "",
          },
          {
            fieldAlias: FieldAlias.D_PERGAMMA_4_BATCH,
            value: formValues?.batch || "",
          },
        ],
      };
    default:
      return undefined;
  }
};
